import { ConfigProvider } from "antd";

export function AntdConfigProvider({ children }) {
    return (
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: "var(--font-family-default), sans-serif" // L1
                }
            }}
        >
            {children}
        </ConfigProvider>
    );
}

/*

[L1]
sans-serif is still needed even though design token has it in case
errors in the app init process if import fails (see catch block of
webapplication/static/js/merchant/init.js)

 */
